export default __webpack_public_path__ + "static/media/image04.1489ccaf.jpg";